import { createActionCreator } from "deox";

import { PageableBillingCycleSummary, PageableStatementInformation } from "../../../types/types";

export const pastChargesLoading = createActionCreator("pastChargesLoading");
export const failed = createActionCreator("failed");
export const morePastChargesLoading = createActionCreator("morePastChargesLoading");
export const pastChargesLoaded = createActionCreator(
  "pastChargesLoaded",
  (resolve) => (charges: PageableBillingCycleSummary, pageIndex: number) => resolve(charges, pageIndex)
);

export const pastChargesMoreLoaded = createActionCreator(
  "pastChargesMoreLoaded",
  (resolve) => (charges: PageableBillingCycleSummary, pageIndex: number) => resolve(charges, pageIndex)
);
/*export const moreBillingCyclesLoaded = createActionCreator(
  "moreBillingCyclesLoaded",
  (resolve) => (charges: PageableBillingCycleSummary) => resolve(charges)
);*/
// Statement Information Actions
export const pastStatementInformationLoading = createActionCreator("pastStatementInformationLoading");
export const morePastStatementInformationLoading = createActionCreator("moreStatementInformationLoading");
export const pastStatementInformationLoaded = createActionCreator(
  "pastStatementInformationLoaded",
  (resolve) => (statementInformation: PageableStatementInformation, pageIndex: number) =>
    resolve(statementInformation, pageIndex)
);
export const morePastStatementInformationLoaded = createActionCreator(
  "morePastStatementInformationLoaded",
  (resolve) => (statementInformation: PageableStatementInformation, pageIndex: number) =>
    resolve(statementInformation, pageIndex)
);
export const resetStatementInformation = createActionCreator("resetStatementInformation");
